/* eslint-disable no-magic-numbers */

export enum PermanentTwilioErrorCodes {
  InvalidPhoneNumber = 21211, // Invalid Phone Number
  DisabledRegion = 21408, // Permission to send an SMS or MMS has not been enabled for the region indicated by the 'To' number
  UnsubscribedRecipient = 21610, // Attempt to send to unsubscribed recipient
  InvalidMobileNumber = 21614, // 'To' number is not a valid mobile number
  CannotBeLandline = 21635, // 'To' number cannot be a landline
  UnreachableHandset = 30003, // Unreachable Destination Handset
  MessageBlocked = 30004, // Message Blocked
  UnknownHandset = 30005, // Unknown Destination Handset
  UnreachableCarrier = 30006, // Landline or Unreachable Carrier
  CarrierViolation = 30007, // Carrier Violation
}

// Map enum values to the array
export const PERMANENT_TWILIO_ERROR_CODES = Object.values(PermanentTwilioErrorCodes);
